import { Button } from "@chakra-ui/react"
import { FiSave } from "react-icons/fi";

const BotaoFinalizarEntrega = ({ isLoading = false }: { isLoading?: boolean }) => {
  return (
    <Button isLoading={isLoading} isDisabled={isLoading} py={6} width="full" colorScheme="green" type="submit">Concluir &nbsp; <FiSave fontSize={18} /> </Button>
  )
}

export default BotaoFinalizarEntrega;